import axios from 'axios';
import { Gizmo } from '../../gizmos';
import { IUserV2 } from '../../types';

interface IParams {
  params: any;
  gizmo: Gizmo;
  context: {
    apiUrl: string;
    user?: IUserV2;
  };
}

/**
 * Get locations from the server, this works for both registers and users.
 *
 * @param {any} params params passed from the UI layer
 * @returns
 */
async function getLocations({ params, gizmo, context }: IParams) {
  const { apiUrl, user } = context;
  const config = gizmo.getConfig();
  const url = `${apiUrl}/main_api/v1/locations/`;

  if (params.fid && user?.credentials) {
    const { fid } = params;
    const requestParams = { type: 'registers', formFid: fid };
    if (config.ops?.index?.rowType === 'system.documents') {
      // Right now we're only supporting users. If we're supporting other system documents,
      // we'll need to update this.
      requestParams.type = 'users';
    }

    const credentials: any = user.credentials;

    const response = await axios.post(url, requestParams, {
      headers: {
        ...credentials,
      },
    });

    if (response.status === 200) {
      const { data } = response;

      const locations = data.locations.map((location: any) => {
        const data: any = {
          id: location.fid,
          name: location.fid,
          lat: location.location.point.coordinates[1],
          lng: location.location.point.coordinates[0],
        };

        if (location.userId && location.username) {
          data.userId = location.userId;
          data.username = location.username;
        }

        // We rearrange the fields to match the format that the map component expects.
        return data;
      });

      return locations;
    }
  }
}

export default getLocations;
